import { mdiTownHall } from '@mdi/js'

export default {
  title: 'School Data',
  to: 'school-data-hob-list',
  icon: mdiTownHall,
  action: 'read',
  resource: 'SchoolDataHeadBranch',
}
